import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import React from 'react';
import { useSelector } from 'react-redux';

import Login from './general/Login';

const useStyles = makeStyles({
  root: {
    zIndex: '4125 !important',
  },
  dialogPaperFullWidth: {
    maxWidth: 'unset',
    border: 'none !important',
    '& > div:first-child': {
      display: 'none',
    },
  },
  muiDialogContent: {
    '& [class*="MuiDialogContent"]': {
      padding: 0,
      overflow: 'hidden',
    },
  },
});

const LoginDialog = () => {
  const classes = useStyles();

  const { isTokenExpired, requireRegistration, requirePasswordChange } = useSelector(
    (state) => state.auth
  );

  return (
    <Modal
      open={isTokenExpired}
      classes={{
        root: classes.root,
        paperFullWidth: classes.dialogPaperFullWidth,
        paper: classes.muiDialogContent,
      }}
      fullScreen
      fullWidth
      disableBackdropClick
      disableEscapeKeyDown
      title=""
      hideButtons
    >
      <Login
        showRegistrationScreen={requireRegistration}
        disablePasswordChangeScreen={!requirePasswordChange}
      />
    </Modal>
  );
};

export default LoginDialog;
